import styled from 'styled-components'

export const ChartWrapper = styled.figure`
  width: 220px;
  margin-top: 20px;
`
